// extracted by mini-css-extract-plugin
export var accordion = "how-it-works-sections-module--accordion--d4fa1";
export var activeImage = "how-it-works-sections-module--activeImage--86298";
export var activeli = "how-it-works-sections-module--activeli--d11f3";
export var container = "how-it-works-sections-module--container--d3eb9";
export var dark = "how-it-works-sections-module--dark--0fdc9";
export var firstImage = "how-it-works-sections-module--firstImage--750c1";
export var firstItem = "how-it-works-sections-module--firstItem--1f37e";
export var header = "how-it-works-sections-module--header--b3858";
export var image = "how-it-works-sections-module--image--945ef";
export var intro = "how-it-works-sections-module--intro--3316b";
export var item = "how-it-works-sections-module--item--ea7b7";
export var items = "how-it-works-sections-module--items--fc7e5";
export var lastImage = "how-it-works-sections-module--lastImage--22a3c";
export var lastItem = "how-it-works-sections-module--lastItem--b0294";
export var light = "how-it-works-sections-module--light--83517";
export var qtitle = "how-it-works-sections-module--qtitle--b8711";
export var questions = "how-it-works-sections-module--questions--ddc7d";
export var section = "how-it-works-sections-module--section--18cf3";
export var sections = "how-it-works-sections-module--sections--7d959";